export class QuestionGroup {
    uuid:string;
    name:string;
    questionCount:number;
}

export function questionGroupSorter(questionGroup1:QuestionGroup, questionGroup2:QuestionGroup):number {
    return questionGroup1.name.localeCompare(questionGroup2.name);
}